

<ng-container *ngIf="isV3Theme; else v2Layout">
  <!-- Layout V3 -->
  <div class="app-container">
    <header>
      <app-sales-header-v3 [hidden]="!showHeader" />
    </header>
    <main>
      <router-outlet />
    </main>
  </div>
</ng-container>

<ng-template #v2Layout>
  <!-- Layout V2 -->
  <main>
    <header>
      <app-sales-header [hidden]="!showHeader" />
    </header>
    <section>
      <router-outlet />
    </section>
  </main>
</ng-template>
